// ko strings for messages/studio.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studio: Dict = {
  // pages/create.tsx
  "studio.title.none": "AI 커버 만들기",
  "studio.title.one": "{name}의 목소리로 부르기",
  "studio.title.many": "이 목소리들로 부르기",
  "studio.section.voice": "목소리",
  "studio.section.whoSings": "누가 부를까요",
  "studio.section.count": "{n}/{max}",
  "studio.section.audio": "오디오",
  "studio.pickVoice": "목소리 선택",
  "studio.pickVoiceNote": "10만 개 이상의 목소리 또는 내 목소리",
  "studio.addVoice": "목소리 추가",
  "studio.whoSingsWhen": "파트별로 부를 사람",
  "studio.sound": "사운드",
  "studio.video": "영상",
  "studio.video.off": "Marble Run에서 목소리들끼리 레이스를 펼쳐 보세요",
  "studio.video.on": "Marble Run · 코인 1개",
  "studio.video.add": "Marble Run 추가 · 코인 1개",
  "studio.coins.unlimited": "Power 플랜은 코인 무제한",
  "studio.coins.one": "코인 {count}개 남음",
  "studio.coins.other": "코인 {count}개 남음",
  "studio.done": "완료",
  "studio.remove": "삭제",
  "studio.cta.pickVoice": "먼저 목소리를 선택하세요",
  "studio.cta.addAudio": "오디오 추가",
  "studio.cta.create": "커버 만들기",
  "studio.auth.video": "가입하고 영상 만들기",
  "studio.auth.audio": "가입하고 내 오디오 사용하기",
  "studio.auth.save": "커버 저장하기",
  "studio.upgrade.marbleRun":
    "Creator로 업그레이드하고 Marble Run 영상을 만들어 보세요",
  "studio.creatorReady":
    "Creator 플랜을 이용 중이에요. Marble Run을 골라 보세요.",
  "studio.maxVoices": "목소리는 최대 {max}개까지 선택할 수 있어요.",
  "studio.alreadyIn": "{name}은(는) 이미 이 커버에 들어 있어요.",

  // VoicePicker
  "studio.voices.search": "목소리 검색",
  "studio.voices.clear": "검색어 지우기",
  "studio.voices.trending": "인기 급상승",
  "studio.voices.recent": "최근 사용",
  "studio.voices.mine": "내 목소리",
  "studio.voices.music": "음악",
  "studio.voices.cartoon": "만화",
  "studio.voices.gaming": "게임",
  "studio.voices.anime": "애니메이션",
  "studio.voices.publicFigure": "유명인",
  "studio.voices.oftenWith": "{name}와(과) 자주 함께",
  "studio.voices.pairedWith": "{name}와(과) 자주 짝지어지는 목소리",
  "studio.voices.add": "{name} 추가",
  "studio.voices.change": "{name} 변경",
  "studio.voices.removeName": "{name} 삭제",
  "studio.voices.upTo": "최대 {max}개",
  "studio.voices.makeDuet": "듀엣으로 만들기",
  "studio.voices.uses": "{n}회 사용",
  "studio.voices.noMatch": "검색과 일치하는 목소리가 없어요.",
  "studio.voices.noMine": "아직 학습한 목소리가 없어요.",
  "studio.voices.noPairs":
    "이번 주에는 아직 이 목소리와의 듀엣이 없어요. 인기 급상승을 둘러보세요.",
  "studio.empty": "아직 아무것도 없어요.",
  "studio.change": "변경",

  // WhoSings
  "studio.who.auto": "자동 선택",
  "studio.who.manual": "직접 고르기",
  "studio.who.chose.one": "직접 선택 · {n}개 파트",
  "studio.who.chose.other": "직접 선택 · {n}개 파트",
  "studio.who.autoExplain": "노래가 바뀌는 지점마다 목소리가 번갈아 불러요.",
  "studio.who.autoCanChoose":
    "직접 정하고 싶나요? 직접 고르기를 누르면 파트마다 부를 목소리를 정할 수 있어요.",
  "studio.who.autoNeedsFile":
    "직접 고르려면 오디오 업로드, 녹음 또는 라이브러리 노래가 필요해요.",
  "studio.who.loading": "노래를 불러오는 중…",
  "studio.who.failed":
    "여기서 이 노래를 재생할 수 없어서 Jammable이 자동으로 정할게요.",
  "studio.who.pause": "일시정지",
  "studio.who.playSong": "노래 재생",
  "studio.who.partLabel": "{name}, {start}~{end}",
  "studio.who.moveSwap": "목소리가 바뀌는 지점 옮기기",
  "studio.who.part": "파트 {n}",
  "studio.who.play": "재생",
  "studio.who.split": "나누기",
  "studio.who.takeOver": "이 파트는 누가 이어서 부를까요?",
  "studio.who.before": "앞 파트",
  "studio.who.after": "뒤 파트",
  "studio.who.sungBy": "부르는 목소리",
  "studio.who.hint":
    "파트를 탭하면 들어 보고 부를 목소리를 고를 수 있어요. 흰색 핸들을 드래그해 목소리가 바뀌는 지점을 옮기세요.",
  "studio.who.tooShort": "각 파트는 최소 {secs}초 이상이어야 해요.",

  // SongPicker
  "studio.song.upload": "업로드",
  "studio.song.library": "라이브러리",
  "studio.song.tts": "텍스트 입력",
  "studio.song.generate": "AI 노래",
  "studio.song.mic": "녹음",
  "studio.song.sources": "노래 가져오기",
  "studio.song.rights": "사용 권리가 있는 오디오만 업로드하세요.",
  "studio.song.search": "노래 검색",
  "studio.song.searchUploads": "내 업로드 검색",
  "studio.song.searchLibrary": "노래 라이브러리 검색",
  "studio.song.popular": "인기",
  "studio.song.yourUploads": "내 업로드",
  "studio.song.noMatch": "검색과 일치하는 노래가 없어요.",
  "studio.song.noUploads": "아직 업로드한 오디오가 없어요.",
  "studio.song.picked": "선택됨",
  "studio.source.generate": "AI 생성",
  "studio.source.upload": "업로드",
  "studio.source.library": "라이브러리",
  "studio.source.mic": "녹음",
  "studio.source.tts": "텍스트 음성 변환",

  // SongSources: Type words
  "studio.tts.what": "어떤 말을 하게 할까요?",
  "studio.tts.placeholder": "말하게 할 내용을 입력하세요...",
  "studio.tts.baseVoice": "기본 목소리",
  "studio.tts.accent": "억양",
  "studio.tts.delivery": "말투",
  "studio.tts.use": "이 텍스트 사용",
  "studio.tts.empty": "텍스트를 입력해 주세요.",
  "studio.tts.tooLong": "텍스트는 최대 {max}자까지 입력할 수 있어요.",
  "studio.tts.gender.female": "여성",
  "studio.tts.gender.male": "남성",
  "studio.tts.accent.US": "미국식",
  "studio.tts.accent.GB": "영국식",
  "studio.tts.accent.FR": "프랑스식",
  "studio.tts.accent.DE": "독일식",
  "studio.tts.accent.ES": "스페인식",
  "studio.tts.accent.IT": "이탈리아식",
  "studio.tts.accent.KR": "한국식",
  "studio.tts.accent.AU": "호주식",
  "studio.tts.accent.JP": "일본식",
  "studio.tts.expr.default": "기본",
  "studio.tts.expr.whispered": "속삭임",
  "studio.tts.expr.happy": "밝게",
  "studio.tts.expr.sad": "슬프게",
  "studio.tts.expr.angry": "화나게",
  "studio.tts.expr.shouting": "외치듯",
  "studio.tts.expr.terrified": "겁에 질린",

  // SongSources: AI song
  "studio.ai.style": "스타일을 고르거나 직접 설명하세요",
  "studio.ai.styleLabel": "노래 스타일",
  "studio.ai.stylePlaceholder":
    "예: 신나는 여름 팝, 어쿠스틱 기타, 중독성 있는 후렴",
  "studio.ai.lyrics": "가사",
  // [Verse], [Chorus], [Bridge] are tags the generator reads: keep them.
  "studio.ai.lyricsPlaceholder":
    "비워 두면 AI가 가사를 써요. 직접 쓰려면:\n\n[Verse 1]\n여기에 가사를 입력하세요...\n\n[Chorus]\n[Verse], [Chorus], [Bridge] 태그로 노래 구성을 정할 수 있어요",
  "studio.ai.ownLyrics": "+ 가사 직접 쓰기 (쓰지 않으면 AI가 써요)",
  "studio.ai.use": "이 노래 사용",
  "studio.ai.noStyle": "노래 스타일을 설명해 주세요.",
  "studio.ai.styleTooLong": "스타일 설명은 {max}자 미만이어야 해요.",
  "studio.ai.lyricsTooLong": "가사는 {max}자 미만이어야 해요.",
  "studio.ai.genre.pop": "팝",
  "studio.ai.genre.trap": "트랩",
  "studio.ai.genre.rnb": "R&B",
  "studio.ai.genre.indie": "인디",
  "studio.ai.genre.kpop": "K팝",
  "studio.ai.genre.edm": "EDM",
  "studio.ai.genre.lofi": "로파이",
  "studio.ai.genre.country": "컨트리",
  "studio.seo.title": "AI 커버 만들기 | Jammable",
  "studio.seo.description":
    "목소리를 고르고 사용 권리가 있는 오디오를 추가해 Jammable에서 AI 커버를 만들어 보세요.",
};

export default studio;
